module.exports = __webpack_public_path__ + "img/avatar_temp.a0ed0ab2.png";